import { CommonModule } from '@angular/common';
import { FeatherModule} from 'angular-feather';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'src/app/shared.module';
import { WidgetsComponentsModule } from 'src/app/components/kit/widgets/widgets-components.module';
import { WorkflowDetailsComponent } from './workflow-details.component';
import { WorkflowModule } from '../../workflow.module';
import { ElementsModule } from '../../../components/elements/elements.module';
import { ReportModule } from '../report/report.module';

const COMPONENTS = [
	WorkflowDetailsComponent,
];

@NgModule({
	imports: [
		CommonModule,
		FeatherModule,
		FormsModule,
		RouterModule,
		SharedModule,
		WidgetsComponentsModule,
		WorkflowModule,
		ElementsModule,
		ReportModule,
	],
	exports: [
		WorkflowDetailsComponent,
	],
	declarations: [...COMPONENTS]
})
export class WorkflowDetailsModule {}
